import { render, staticRenderFns } from "./TableOtFromAudit.vue?vue&type=template&id=036346a3&scoped=true"
import script from "./TableOtFromAudit.vue?vue&type=script&lang=js"
export * from "./TableOtFromAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036346a3",
  null
  
)

export default component.exports